<header class="top-0 left-0 w-full bg-white shadow-md border-b border-gray-200" style="z-index: 900;">
  <div class="w-full flex items-center justify-between py-3 px-6">
    <!-- Logo (Center on larger screens) -->
    <a routerLink="/" routerLinkActive="active" class="flex items-center space-x-2 group ml-12">
      <img src="images/logo.png" alt="ClearScrap Logo" class="h-10 transition-transform group-hover:scale-105" />
    </a>

    <!-- Right Side - User Menu -->
    <nav class="flex items-center justify-end">
      <!-- User Profile Menu -->
      <div class="relative user-dropdown">
        <ng-container *ngIf="user; else loginBlock">
          <button (click)="toggleUserMenu($event)"
            class="flex items-center space-x-2.5 px-3 py-1.5 text-gray-700 hover:bg-gray-50 transition-all duration-200 rounded-lg border border-gray-200 hover:border-gray-300">
            <div
              class="w-9 h-9 bg-gradient-to-br from-green-400 to-blue-500 rounded-full flex items-center justify-center text-white text-sm font-bold shadow-sm">
              {{ getUserInitials() }}
            </div>
            <div class="hidden md:flex flex-col items-start">
              <span class="text-sm font-semibold text-gray-800 leading-tight">{{ user.name }}</span>
              <span class="text-xs text-gray-500">{{ partnerUser?.outletName || 'Partner' }}</span>
            </div>
            <i class="fas fa-chevron-down text-xs transition-transform duration-200 text-gray-400"
              [class.rotate-180]="userMenuOpen"></i>
          </button>

          <!-- User Dropdown Menu -->
          <div *ngIf="userMenuOpen"
            class="absolute top-full right-0 mt-2 w-64 bg-white rounded-xl shadow-xl border border-gray-100 py-2 z-50 animate-dropdown">
            <div class="px-4 py-3 border-b border-gray-100">
              <p class="text-sm font-semibold text-gray-900">{{ user.name }}</p>
              <p class="text-xs text-gray-500 mt-0.5">{{ getUserEmail() }}</p>

              <div class="mt-3 space-y-2.5">
                <div *ngIf="partnerUser?.partnerName"
                  class="bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg p-2 border border-green-200">
                  <span class="text-xs text-green-600 font-medium">Partner</span>
                  <p class="text-sm text-green-800 font-bold mt-0.5">{{ partnerUser?.partnerName }}</p>
                </div>

                <div *ngIf="partnerUser?.outletName"
                  class="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-2 border border-blue-200">
                  <span class="text-xs text-blue-600 font-medium">Outlet</span>
                  <p class="text-sm text-blue-800 font-bold mt-0.5">{{ partnerUser?.outletName }}</p>
                </div>
              </div>

            </div>
            <button (click)="logout(); closeAllMenus()"
              class="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-red-50 hover:text-red-600 transition-all flex items-center">
              <i class="fas fa-sign-out-alt mr-3 w-4"></i>Logout
            </button>
          </div>
        </ng-container>
        <ng-template #loginBlock>
          <button (click)="login()"
            class="px-5 py-2.5 bg-gradient-to-r from-green-600 to-green-500 text-white rounded-lg hover:from-green-700 hover:to-green-600 transition-all duration-200 shadow-sm hover:shadow font-medium">
            <i class="fas fa-sign-in-alt mr-2"></i>Login
          </button>
        </ng-template>
      </div>
    </nav>
  </div>
</header>